import React from 'react';

export default function CompromisoPagoFormModal({
  isOpen,
  dialogId = 'compromiso-pago-title',
  eyebrow = 'Gestión de moras',
  title,
  prestamo,
  summary,
  highlight,
  formData,
  errors,
  saving,
  onClose,
  onChange,
  onSubmit,
  minFechaCompromiso,
  submitLabel,
  savingLabel
}) {
  if (!isOpen || !prestamo) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={dialogId}
        className="modal-panel modal-panel-md p-6"
      >
        <div>
          {eyebrow ? <p className="text-xs font-semibold uppercase tracking-[0.18em] text-red-600">{eyebrow}</p> : null}
          <h3 id={dialogId} className="modal-title mt-2">
            {title}
          </h3>
          {summary}
        </div>

        {highlight}

        <form className="mt-6 space-y-4" onSubmit={onSubmit}>
          <div>
            <label htmlFor="fecha_compromiso" className="modal-label">
              Fecha compromiso
            </label>
            <input
              id="fecha_compromiso"
              name="fecha_compromiso"
              type="date"
              min={minFechaCompromiso || undefined}
              value={formData.fecha_compromiso}
              onChange={onChange}
              disabled={saving}
              required
              className={`modal-input ${errors.fecha_compromiso ? 'border-red-500' : ''}`}
            />
            {errors.fecha_compromiso ? (
              <p className="mt-1 text-xs text-red-600">{errors.fecha_compromiso}</p>
            ) : null}
          </div>

          <div>
            <label htmlFor="monto_compromiso" className="modal-label">
              Monto compromiso
            </label>
            <input
              id="monto_compromiso"
              name="monto_compromiso"
              type="number"
              inputMode="decimal"
              min="0"
              step="0.01"
              value={formData.monto_compromiso}
              onChange={onChange}
              disabled={saving}
              required
              placeholder="0.00"
              className={`modal-input input-no-spinner ${errors.monto_compromiso ? 'border-red-500' : ''}`}
            />
            {errors.monto_compromiso ? (
              <p className="mt-1 text-xs text-red-600">{errors.monto_compromiso}</p>
            ) : null}
          </div>

          <div>
            <label htmlFor="motivo" className="modal-label">
              Motivo
            </label>
            <textarea
              id="motivo"
              name="motivo"
              value={formData.motivo}
              onChange={onChange}
              disabled={saving}
              required
              rows={5}
              placeholder="Describe el acuerdo alcanzado con el cliente."
              className={`modal-textarea ${errors.motivo ? 'border-red-500' : ''}`}
            />
            {errors.motivo ? (
              <p className="mt-1 text-xs text-red-600">{errors.motivo}</p>
            ) : null}
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              disabled={saving}
              className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={saving}
              className="rounded-xl bg-red-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {saving ? savingLabel : submitLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}